import './index.scss';
import Flex from '../Flex';
import classNames from 'classnames';

export interface SwitchGroupsItem {
  key: string;
  name: string;
}

export interface SwitchGroupsProps {
  selected: string;
  items: SwitchGroupsItem[];
  onTabChange: (value: string) => void;
}

export function SwitchGroup({
  items,
  selected,
  onTabChange = () => { }
}: SwitchGroupsProps) {

  return (
    <Flex className="app-switch-group">
      {items.map(item => (
        <Flex
          key={item.key}
          onClick={onTabChange.bind({}, item.key)}
          className={classNames(
            'switch-group-item',
            { 'switch-group-item-active': selected === item.key }
          )}>
          {item.name}
        </Flex>
      ))}
    </Flex>
  );
};

export default SwitchGroup;
